import { ZOOM_CONSTANTS } from '../../../utils/appConstants';

const ZoomFunction = ((engine: any, event: any = null, step = 0) => {
  const { minScale, maxScale, scrollSpeed } = ZOOM_CONSTANTS;
  const model = engine.getModel();
  const canvas = engine.getCanvas();
  if (event) {
    const direction = scrollSpeed * (-event.event.deltaY / Math.abs(event.event.deltaY)); // will return -1 or 1

    let newZoomFactor = model.getZoomLevel() - event.event.deltaY / Math.abs(event.event.deltaY / 2);
    if (newZoomFactor <= 0.1) {
      return;
    }
    newZoomFactor = newZoomFactor + direction + (direction * newZoomFactor * 5) / maxScale;
    const oldZoomFactor = model.getZoomLevel();

    const boundingRect = canvas.getBoundingClientRect();
    const clientWidth = boundingRect.width;
    const clientHeight = boundingRect.height;

    // compute difference between rect before and after scroll
    const widthDiff = clientWidth * newZoomFactor - clientWidth * oldZoomFactor;
    const heightDiff = clientHeight * newZoomFactor - clientHeight * oldZoomFactor;

    // compute mouse coords relative to canvas
    const clientX = event.event.clientX - boundingRect.x;
    const clientY = event.event.clientY - boundingRect.y;

    // compute width and height increment factor
    const xFactor = (clientX - model.getOffsetX()) / oldZoomFactor / clientWidth;
    const yFactor = (clientY - model.getOffsetY()) / oldZoomFactor / clientHeight;

    if ((newZoomFactor > minScale && direction < 0) || (newZoomFactor < maxScale && direction > 0)) {
      model.setZoomLevel(newZoomFactor);
      model.setOffset(model.getOffsetX() - widthDiff * xFactor, model.getOffsetY() - heightDiff * yFactor);
    }
  } else if (step !== 0) {
    const direction = -step; // will return -1 or 1

    let newZoomFactor = model.getZoomLevel() - step / Math.abs(step / 2);
    if (newZoomFactor <= 0.1) {
      return;
    }
    newZoomFactor = newZoomFactor + direction + (direction * newZoomFactor * 5) / maxScale;
    const oldZoomFactor = model.getZoomLevel();

    const boundingRect = canvas.getBoundingClientRect();
    const clientWidth = boundingRect.width;
    const clientHeight = boundingRect.height;

    // compute difference between rect before and after scroll
    const widthDiff = clientWidth * newZoomFactor - clientWidth * oldZoomFactor;
    const heightDiff = clientHeight * newZoomFactor - clientHeight * oldZoomFactor;

    // compute mouse coords relative to canvas
    const clientX = (clientWidth - boundingRect.x) / 2;
    const clientY = (clientHeight - boundingRect.y) / 2;

    // compute width and height increment factor
    const xFactor = (clientX - model.getOffsetX()) / oldZoomFactor / clientWidth;
    const yFactor = (clientY - model.getOffsetY()) / oldZoomFactor / clientHeight;

    if ((newZoomFactor > minScale && direction < 0) || (newZoomFactor < maxScale && direction > 0)) {
      model.setZoomLevel(newZoomFactor);
      model.setOffset(model.getOffsetX() - widthDiff * xFactor, model.getOffsetY() - heightDiff * yFactor);
    }
  }
  // engine?.fireEvent({}, "onCanvasMove");
  engine.repaintCanvas();
});

export default ZoomFunction;
